import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface AddEnterpriseInterface {
  enterpriseName: string;
  email: string;
  address: string;
  password: string;
  BRNumber: string;
  phone: string;
  packages: string;
}

export const useAddEnterprise = () => {
  const mutate = useMutation(
    ({
      enterpriseName,
      email,
      address,
      password,
      BRNumber,
      phone,
      packages,
    }: AddEnterpriseInterface) => {
      return postAPI('/external-api/add_enterprise_acc', {
        enterprise_name: enterpriseName,
        email,
        address,
        password,
        br_number: BRNumber,
        phone,
        package: packages,
      });
    },
  );

  return mutate;
};

export default useAddEnterprise;
